export default __webpack_public_path__ + "static/media/solflare.6804d45c.svg";